export default {
	state: {
		geo: {},
		invoice: '',
		plan: '',
		requestId: '',
		requestDescription: '',
		requestDocuments: '',
		requestPart: '',
		requestType: '',
		messages: [],
		errors: [],
	},
	getters: {
		errors(state) {
			return state.errors
		},
		messages(state) {
			return state.messages
		},
	},
	mutations: {
		clearErrors(state) {
			// Clear errors from state
			state.errors = []
		},
		clearRequestCreateFields(state) {
			state.geo = {}
			state.invoice = ''
			state.plan = ''
			state.requestId = ''
			state.requestDescription = ''
			state.requestDocuments = ''
			state.requestPart = ''
			state.requestType = ''
		},
		destroyError(state, data) {
			// Delete error from state
			let indexError = -1

			Object.entries(state.errors).forEach(([indexErr, error]) => {
				// Check current error
				if (error !== undefined && error.field === data.field) {
					indexError = indexErr
				}
			})

			// Delete error
			if (indexError !== -1) {
				state.errors.splice(indexError, 1)
			}
		},
		setGeo(state, payload) {
			state.geo.address_full = payload.address_full
			state.geo.city = payload.city
			state.geo.province_id = payload.province_id
			state.geo.country_id = payload.country_id
			state.geo.latitude = payload.latitude
			state.geo.longitude = payload.longitude
		},
		setInvoice(state, payload) {
			state.invoice = payload.invoice
		},
		setPlan(state, payload) {
			state.plan = payload.plan
		},
		setRequestDescription(state, payload) {
			state.requestDescription = payload.requestDescription
		},
		setRequestDocuments(state, payload) {
			state.requestDocuments = payload.requestDocuments
		},
		setRequestPart(state, payload) {
			state.requestPart = payload.requestPart
		},
		setRequestType(state, payload) {
			state.requestType = payload.requestType
		},
		setRequestId(state, payload) {
			state.requestId = payload.requestId
		},
		setError(state, data) {
			// Add error to state
			state.errors.push(data)
		},
	},
	actions: {
		clearErrors(context) {
			context.commit('clearErrors')
		},
		clearRequestCreateFields(context) {
			context.commit('clearRequestCreateFields')
		},
		destroyError(context, data) {
			// Commit mutation
			context.commit('destroyError', {
				field: data.field,
			})
		},
		storeError(context, data) {
			// Commit mutation
			context.commit('setError', {
				field: data.field,
				type: data.type,
				values: data.values ? data.values : '',
			})
		},
	},
}



// WEBPACK FOOTER //
// ./src/store/modules/misc.js